import cloneDeep from 'lodash.clonedeep';
import type { EnhancedProperty } from '../../@types/item';
import { getMarket } from '../../i18n';

const PROPERTY_BLACK_LIST = Object.freeze([
  'towHitchFoldable',
  'trailerTotalWeightB',
  'gps',
  'androidAuto',
  'appleCarPlay',
  'tintedWindows',
  'maxTrailerLoadUnbraked',
]);

const isForbiddenProperty = (key: string) => PROPERTY_BLACK_LIST.includes(key);

const MOLLER_BIL_FORBIDDEN_PROPERTIES = [
  'maxLoadWeight',
  'maxRoofWeight',
  'serviceWeight',
  'electricalRangeWLTP',
];
const NO_FORBIDDEN_PROPERTIES = ['trailerTotalWeight'];

const isForbiddenMollerBilProperty = (key: string) => MOLLER_BIL_FORBIDDEN_PROPERTIES.includes(key);
const isForbiddenNoProperty = (key: string) => NO_FORBIDDEN_PROPERTIES.includes(key);

const CATEGORY_WHITE_LIST = Object.freeze([1, 2, 6, 8, 71, 119, 117, 1000]);

const hasForbiddenCategory = (property: EnhancedProperty) =>
  !property.category ||
  !property.category.id ||
  !CATEGORY_WHITE_LIST.includes(property.category.id);

export default (properties: { [key: string]: EnhancedProperty }, isMollerBil?: boolean) => {
  const newProperties = cloneDeep(properties);
  const market = getMarket().marketCode;

  Object.keys(properties).forEach((key) => {
    const property = properties[key];

    if (hasForbiddenCategory(property)) {
      delete newProperties[key];
    } else if (isForbiddenProperty(key)) {
      delete newProperties[key];
    } else if (isMollerBil && isForbiddenMollerBilProperty(key)) {
      delete newProperties[key];
    } else if (market === 'NO' && isForbiddenNoProperty(key)) {
      delete newProperties[key];
    }
  });

  return newProperties;
};
